<template>
  <v-app light>
    <v-navigation-drawer v-model="showMenu" fixed left temporary app v-if="isAuthenticated()">
      <v-list>
        <v-list-tile to="/">
          <v-icon class="ma-3">commute</v-icon>
          <v-list-tile-title class="title">moje dostave</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/profile">
          <v-icon class="ma-3">person</v-icon>
          <v-list-tile-title class="title">profil</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/balance" v-if="user.isCourier">
          <v-icon class="ma-3">euro_symbol</v-icon>
          <v-list-tile-title class="title">stanje računa</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/events">
          <v-icon class="ma-3">timeline</v-icon>
          <v-list-tile-title class="title">dešavanja</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/users" v-if="user.isAdmin">
          <v-icon class="ma-3">people</v-icon>
          <v-list-tile-title class="title">korisnici</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/couriers" v-if="user.isProxy">
          <v-icon class="ma-3">people</v-icon>
          <v-list-tile-title class="title">kuriri</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/mobile-application">
          <v-icon class="ma-3">android</v-icon>
          <v-list-tile-title class="title">android aplikacija</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout">
          <v-icon class="ma-3">input</v-icon>
          <v-list-tile-title class="title">odjava</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="primary" dark fixed app prominent v-if="isAuthenticated()">
      <v-btn style="width: 60px; height: 60px;" icon light @click.prevent="showMenu=!showMenu">
        <img src="https://lanser.rs/img/icons/lanser-32x32.png"><img>
      </v-btn>
      <v-toolbar-title class="clickable headline" @click.prevent="home()">lanser</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!$router.currentRoute.path.includes('/events')"
        icon large class="hidden-sm-and-down"
        @click.prevent="toggleMessages()">
        <v-badge :value="unreadMessages!=0" overlap color="secondary">
          <span slot="badge" secondary>{{unreadMessages}}</span>
          <v-icon>storage</v-icon>
         </v-badge>
      </v-btn>
      <span class="subheading">{{ userFormatted }}</span>
      <span class="ml-4">
        <i v-if="!connectivityStatus.healthy" class="fas fa-exclamation-circle fa-2x" title="Nema Interneta"></i>
        <i v-if="connectivityStatus.working && connectivityStatus.healthy" class="fas fa-times-circle fa-spin fa-2x" title="Učitavanje..."></i>
        <i v-if="!connectivityStatus.working && connectivityStatus.healthy" class="fas fa-circle fa-2x" title="Stabilna veza"></i>
      </span>
      <!-- <span> [{{ $vuetify.breakpoint.name }}]</span> -->
    </v-toolbar>
    <v-content>
      <router-view></router-view>
      <v-navigation-drawer v-model="showMessages" clipped hide-overlay fixed right v-if="isAuthenticated()" class="zi1 hidden-sm-and-down">
        <messages class="below-toolbar px-0" />
      </v-navigation-drawer>
    </v-content>
    <template v-if="logEntries.length > 0 && debug">
      <v-btn @click.prevent="clearLogs()">clear logs</v-btn>
      <v-alert v-for="(log, i) in logEntries" :key="i" class="w100" v-model="log.visible" type="info" dismissible>
        {{log.entry}}
      </v-alert>
    </template>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import auth from '@/services/authService.js'
  import userService from '@/services/userService'
  import cordovaService from '@/services/cordovaService.js'
  import { log, getLogEntries, clearLogs } from '@/services/logService.js'
  import messages from '@/components/Messages'
  import connectivityTrackingService from '@/services/connectivityTrackingService'

  export default {
    data () {
      return {
        cordova: Vue.cordova,
        logEntries: getLogEntries(),
        showMenu: false,
        showMessages: false,
        user: auth.getCurrentUser(),
        messages: auth.isAuthenticated() ? userService.getMessages() : [],
        connectivityStatus: connectivityTrackingService.getStatus()
      }
    },
    components: {
      messages
    },
    created () {
      cordovaService.initialize(this)
      log('App created')
    },
    methods: {
      isAuthenticated () {
        return auth.isAuthenticated()
      },
      profile () {
        this.$router.push('/profile')
      },
      logout () {
        userService.updateAndroidRegistration(null).finally(() => {
          auth.logout()
          this.showMenu = false
          this.$router.push('/login')
        })
      },
      home () {
        this.$router.push('/')
      },
      clearLogs () {
        clearLogs()
      },
      toggleMessages () {
        this.showMessages = !this.showMessages
        if (this.showMessages) {
          userService.markMessagesRead()
        }
      }
    },
    computed: {
      debug () {
        let isDebugUser = this.user.email && this.user.email.replace('.', '').indexOf('mravns') !== -1
        return isDebugUser
      },
      userFormatted () {
        let formatted = ''
        if (this.user.roles) {
          if (this.user.roles.indexOf('admin') !== -1) {
            formatted = 'admin: '
          } else if (this.user.roles.indexOf('courier') !== -1 && this.user.roles.indexOf('store') !== -1) {
            formatted = 'radnja&kurir: '
          } else if (this.user.roles.indexOf('courier') !== -1) {
            formatted = 'kurir: '
          } else if (this.user.roles.indexOf('store') !== -1) {
            formatted = 'radnja: '
          }
        }
        if (this.user.name) {
          formatted += this.user.name
        }
        return formatted
      },
      unreadMessages () {
        return this.messages.reduce((acc, cur) => acc + (cur.read ? 0 : 1), 0)
      }
    }
  }
</script>

<style>
  body {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    /* text-transform: uppercase; */
  }
  .footer { /* Apply this to v-bottom-nav if necessary. */
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
  }
  .clickable {
    cursor: pointer;
  }
  .w100 {
    width: 100%;
  }
  .zi1 {
    z-index: 1;
  }
  .below-toolbar {
    /* top: 75px !important; */
    margin-top: 75px;
  }
</style>
